/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import { CommandIntelligenceScreenContext } from './context';

const CommandIntelligenceScreenProvider = ({ children, value }) => {
  return (
    <CommandIntelligenceScreenContext.Provider value={value}>{children}</CommandIntelligenceScreenContext.Provider>
  );
};

export default CommandIntelligenceScreenProvider;
